import React, { useEffect, useRef } from "react";

const MatrixBackground = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");

    const resize = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };
    resize();
    window.addEventListener("resize", resize);

    const symbols =
      "アイウエオカキクケコサシスセソタチツテトナニヌネノ01アBCDEF0123456789@#$%";
    const fontSize = 13;

    let columns = Math.floor(canvas.width / fontSize);
    let drops = Array(columns).fill(1);

    // Column color types: 0=green, 1=cyan, 2=dim-green
    const colTypes = Array.from({ length: columns }, () =>
      Math.floor(Math.random() * 10),
    );
    const colorMap = (type) => {
      if (type === 0) return "#00ff99"; // bright green (10%)
      if (type === 1) return "#06b6d4"; // cyan (10%)
      return "#00aa55"; // dim green (80%)
    };

    const drawMatrix = () => {
      ctx.fillStyle = "rgba(5, 10, 14, 0.06)";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.font = `${fontSize}px monospace`;

      for (let i = 0; i < drops.length; i++) {
        const char = symbols[Math.floor(Math.random() * symbols.length)];
        const color = colorMap(colTypes[i]);
        ctx.fillStyle = color;
        ctx.globalAlpha = drops[i] * fontSize < 30 ? 1 : 0.7;
        ctx.fillText(char, i * fontSize, drops[i] * fontSize);
        ctx.globalAlpha = 1;

        if (drops[i] * fontSize > canvas.height && Math.random() > 0.972) {
          drops[i] = 0;
          colTypes[i] = Math.floor(Math.random() * 10);
        }
        drops[i]++;
      }
    };

    const interval = setInterval(drawMatrix, 38);
    return () => {
      clearInterval(interval);
      window.removeEventListener("resize", resize);
    };
  }, []);

  return (
    <div className="absolute inset-0 z-0 overflow-hidden">
      <div className="absolute inset-0 bg-[#050a0e] pointer-events-none" />
      <canvas
        ref={canvasRef}
        className="absolute inset-0 w-full h-full opacity-50"
      />
    </div>
  );
};

export default MatrixBackground;
